
export const nwBreakpoints = {
  xs: 0,
  sm: 768,
  md: 1080,
  lg: 1280,
  xl: 1440,
  xxl: 1576,
};

function createBreakpointTokens() {
  return Object.fromEntries(
    Object.entries(nwBreakpoints)
      .filter(([key]) => key !== 'xs')
      .map(([key, value]) => [key, `${value}px`])
  );
}

export const breakpoints = createBreakpointTokens();
